/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Error_Page_TitleInputs */

const de_commons_error_page_title = /** @type {(inputs: Commons_Error_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etwas ist schiefgelaufen`)
};

/** @type {(inputs: Commons_Error_Page_TitleInputs) => LocalizedString} */
const en_commons_error_page_title = de_commons_error_page_title;

/**

* @param {Commons_Error_Page_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_page_title = /** @type {((inputs?: Commons_Error_Page_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_Page_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_page_title(inputs)
	return en_commons_error_page_title(inputs)
});